/* eslint-disable max-len */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { IconButton, Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import { css } from '@emotion/core';

const SnackbarStyle = css`
  .MuiTypography-root {
    background-color: #d32f30 !important;
  }
  #client-snackbar {
    display: flex;
    align-items: center;
  }

  .errorIcon {
    font-size: 20;
    opacity: 0.9;
    margin-right: 10px;
  }
`;

const UnauthorizedSnackbar = ({ message, closeLink }) => {
  const history = useHistory();
  const handleClose = () => {
    history.push(closeLink);
  };

  return (
    <Snackbar
      css={SnackbarStyle}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open
      autoHideDuration={3000}
      onClose={handleClose}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={
        <span id="client-snackbar">
          <ErrorIcon className="errorIcon" />
          {message}
        </span>
      }
      action={
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      }
    />
  );
};

export default UnauthorizedSnackbar;
